import { addDoc, collection } from "firebase/firestore";
import { IFormInput } from "../../../models";
import { fsDb } from '../../firebase/config';
import { writeBatch, doc } from "firebase/firestore";

// Get a new write batch


export default class ApiContacts {
    static postContactInfo = async (data: IFormInput) => {
        // console.log(data, "from contact form");
        try {
            const docRef = await addDoc(collection(fsDb, "dev/tables/connections"), {
                n: data.name,
                e: data.email,
                ph: data.phone,
                msg: data.msg,
            });
            if (docRef.id) {
                return true;
            }
        } catch (e) {
            console.error("Error adding document: ", e);
            return false;
        }
    }




    static batchWrite = async () => {
        const datab = [
            {
                "title": "Saveo Admin",
                "description": "",
                "summary": "A B2B E-commerce Platform in pharmaceutical ecosystem, connecting local pharmacies and  by re-engineering the complete supply chain.",
                "thumbnail": "",
                "txt":"Saveo is a B2B E-commerce platform, I was responsible for building the project from start to end, The web app is built with Angular8 and few other libraries like RxJS (reactive programming), Angular Material Design, Flexbox, SCSS, Google Firebase Authentication.",
                "type": "Dashboard",
                "open": false,
                "languages": [
                    "angular",
                    "firebase",
                    "angular-material",
                    "reactivejs"
                ]
            },
            {
                "title": "PlanB",
                "description": "",
                "summary": "A EdTech Platform that provides IIT-JEE students with interactive app for learning with audio books/ videos solutions.",
                "thumbnail": "",
                "txt":"",
                "type": "Dashboard",
                "open": false,
                "languages": [
                    "angular",
                    "firebase",
                    "angular-material",
                    "ngrx"
                ]
            },
            {
                "title": "Thisability",
                "description": "",
                "summary": "A social commerce platform for people with disabilities, helping brands in better engagement with customers accodring to socail behaviours.",
                "thumbnail": "",
                "txt":"",
                "type": "Web app",
                "open": false,
                "languages": [
                    "angular",
                    "angular-material",
                    "firebase",
                    "ngrx",
                    "reactivejs"
                ]
            },
            {
                "title": "Sneed",
                "description": "",
                "summary": "A Platform that provides access to a coworking space, office-infrastructure support, with key services, Flexible and ready to use with minimal investment.",
                "thumbnail": "",
                "txt":"",
                "type": "Web app",
                "open": false,
                "languages": [
                    "react",
                    "typescript",
                    "material-ui",
                    "redux",
                    "scss"
                ]
            },
            {
                "title": "E-locals",
                "description": "",
                "summary": "A E-commerce platform that is trying to digitally bridge the gap between local merchants and local customers on the online marketplace.",
                "thumbnail": "",
                "txt":"",
                "type": "Web app",
                "open": false,
                "languages": [
                    "react",
                    "material-ui",
                    "redux",
                    "css"
                ]
            },
            {
                "title": "Intugine",
                "description": "",
                "summary": "A logistics technology company that builds reliable, sustainable digital solutions for every supply chain challenge.",
                "thumbnail": "",
                "txt":"",
                "type": "Static",
                "open": false,
                "languages": [
                    "angular",
                    "angular-material",
                    "Typescript",
                    "sass"
                ]
            },
            {
                "title": "parikshapro",
                "description": "",
                "summary": "A EdTech platform that offers online tutoring classes and study materials for students evaluate students performance, behavior tracking, analytics.",
                "thumbnail": "",
                "txt":"",
                "type": "Dashboard",
                "open": false,
                "languages": [
                    "angular",
                    "angular-material",
                    "Typescript",
                    "material-ui",
                    "reactivejs",
                    "sass"
                ]
            },
            {
                "title": "Api Platform",
                "description": "",
                "summary": "A platform for automated API Engineering & Management, automates all the steps in the API development cycle so customers can achieve integration.",
                "thumbnail": "",
                "txt":"",
                "type": "Static",
                "open": false,
                "languages": [
                    "angular",
                    "angular-material",
                    "Typescript",
                    "sass"
                ]
            },
            {
                "title": "Intu-Track",
                "description": "",
                "summary": "A Admin Dashboard for logistics management, which provides live tracking, analytics and much more.",
                "thumbnail": "",
                "txt":"At Initial days of my work contribution to Intu-track Dashboard was to code certain modules of the project, referencing the designs, made using Adobe Xd by the Design team.",
                "type": "dashboard",
                "open": false,
                "languages": [
                    "angular",
                    "angular-material",
                    "mapbox",
                    "ngrx",
                    "sass"
                ]
            },
            {
                "title": "Automobees",
                "description": "Automobees is a platform that makes it easy to manage parking for both the parking provider as well as the parking user. The Admin dashboard can be used to control and monitor the users, parking area guards, Parking Area Managers and much more.",
                "summary": "A Parking Management platform to make parking easier to both the parking user and the parking provider.",
                "thumbnail": "",
                "txt":"",
                "type": "dashboard",
                "open": false,
                "languages": [
                    "angular",
                    "ngrx",
                    "firebase",
                    "angular-material",
                    "sass",
                    "monogodb"
                ]
            },
            {
                "title": "Saveo",
                "description": "",
                "summary": "A stationary website for Saveo to establish the organization's credibility and  communicate the brand value and to convey professionalism.",
                "thumbnail": "",
                "txt":"",
                "type": "static",
                "open": false,
                "languages": [
                    "typescript",
                    "react",
                    "firebase",
                    "material-ui",
                    "redux"
                ]
            },
            {
                "title": "Treeform",
                "description": "Treeform is a webapp to demonstrate the Angular animations, PWA, SSR (Angular Universal) it is a open source contribution.",
                "summary": "A open source contribution web app with Angular Animations and PWA, Server Side Rendering support.",
                "thumbnail": "",
                "txt":"",
                "type": "static",
                "open": true,
                "languages": [
                    "angular",
                    "angular-material",
                    "angular-pwa",
                    "sass",
                    "angular-animations",
                    "angular-universal"
                ]
            }
        ]
        try {
            const batch = writeBatch(fsDb);


            datab.forEach((docq,index) => {
                let pRef = doc(collection(fsDb, "dev/tables/projects"));
                let medRef = doc(collection(fsDb, "dev/tables/media"));
                batch.set(pRef, docq, {merge: true});
                batch.set(medRef, { "fKey": pRef.id, "pname": docq.title, "txt": docq.txt,  "images": ["1","2","3","4"]}, { merge: true });
            });


            // Commit the batch
            batch.commit().then(() => {
                console.log('done');
            });
            // const docRef = await addDoc(collection(fsDb, "dev/tables/connections"), {
            //     n: data.name,
            //     e: data.email,
            //     ph: data.phone,
            //     msg: data.msg,
            // });
            // if (docRef.id) {
            //     return true;
            // }
        } catch (e) {
            console.error("Error adding document: ", e);
            return false;
        }
    }
}


